package ai.wagemix.net.client

import ai.wagemix.net.models.WMAccountCreate
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/accounts`: creates the account and sends the welcome email; needs no authorization. */
class WMCreateAccountRequestBuilder: FSRequestBuilder<WMCreateAccountRequestBuilder, WMAccountCreate>() {

    override fun build(): FSRequest<WMAccountCreate> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "accounts")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMCreateAccountRequestBuilder = this
}
